import { render } from "./ai-subtitle.vue?vue&type=template&id=50f31fbd&scoped=true"
import script from "./ai-subtitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-subtitle.vue?vue&type=script&setup=true&lang=js"

import "./ai-subtitle.vue?vue&type=style&index=0&id=50f31fbd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f31fbd"],['__file',"src/components/ai-subtitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50f31fbd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50f31fbd', __exports__)) {
    api.reload('50f31fbd', __exports__)
  }
  
  module.hot.accept("./ai-subtitle.vue?vue&type=template&id=50f31fbd&scoped=true", () => {
    api.rerender('50f31fbd', render)
  })

}


export default __exports__